// extracted by mini-css-extract-plugin
export default {"root":"AfAJV8O2rGVUmuCPazHM","single-col":"v36RzbX1lUUljBFAfCoW","singleCol":"v36RzbX1lUUljBFAfCoW"};